export default [{
  path: '/view3D',
  name: 'view3D',
  component: () => import('@/views/js3D/index'),
}]
